// src/hooks/useProducts.js
import { useQuery } from "@tanstack/react-query";
import api from "../api/axiosClient";

export default function useProducts() {
  return useQuery({
    queryKey: ["products"],
    queryFn: async () => {
      const res = await api.get("/product");
      console.log("Fetched products:", res.data);
      return res.data;
    },
    staleTime: 1000 * 60 * 30,      // 30 minutes
    cacheTime: 1000 * 60 * 120,     // 2 hours
    refetchOnWindowFocus: true,
    refetchOnMount: false,
    refetchOnReconnect: true,
  });
}
